module.exports = __webpack_public_path__ + "static/img/case_logo_17.48708a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_logo_17.png
// module id = fHLo
// module chunks = 34